import {
  TRAINING_AUTH_ACTION,
  TRAINING_AUTH_KEY
} from 'modules/training/modules/app-auth/constants'
import updateTrainingAuthAction from 'modules/training/modules/app-auth/actions/update'

function toggleLogInTypeTrainingAuthAction (value) {
  return updateTrainingAuthAction({
    type: value ? TRAINING_AUTH_ACTION.UPDATE_TO_SIGN_UP : TRAINING_AUTH_ACTION.UPDATE_TO_LOG_IN,
    payload: {
      key: TRAINING_AUTH_KEY.IS_SIGN_UP,
      value
    }
  })
}

export default toggleLogInTypeTrainingAuthAction
